<template lang="pug">
div
  v-combobox.search-field(:items='list' :filter='filter' hide-no-data clearable hide-details label='搜尋' :searchInput='value' @update:searchInput='handleChange' prepend-icon='search' item-value='value' item-text='value')
    template(v-slot:item='{ item, parent }')
      v-list-tile-content
        v-list-tile-sub-title {{ getFieldName(item.type) }}
        v-list-tile-title(v-html="`${parent.genFilteredText(item.value)}`")
    slot(name='append-outer' slot='append-outer')
</template>

<script>
import { caseInsensitiveIncludes } from '@/modules/caseInsensitiveIncludes'
import { computed } from '@vue/composition-api'

export default {
  name: 'FormSearch',
  props: {
    value: String,
    forms: Array,
    headers: Array,
  },
  setup (props, { emit }) {
    function handleChange (value) {
      emit('input', value?.trim() ?? '')
    }

    function filter (item, query) {
      return query && caseInsensitiveIncludes(item.value, query)
    }

    const headerValueTextMap = computed(() => {
      const map = {}

      props.headers.forEach((header) => {
        map[header.value] = header.text
      })

      return map
    })

    function getFieldName (type) {
      return headerValueTextMap.value[type]
    }

    const list = computed(() => {
      if (!props.forms) return []
      const searchableField = ['name', 'school', 'song']
      const map = {}

      searchableField.forEach(field => {
        map[field] ??= new Set()
        props.forms.forEach((form) => {
          const value = form[field]
          if (!value) return
          map[field].add(form[field])
        })
      })

      const list = []
      Object.entries(map).forEach(([type, set]) => {
        list.push(
          ...[...set].map(value => ({ type, value }))
        )
      })

      return list
    })

    return {
      handleChange,
      filter,
      getFieldName,
      list,
    }
  },
}
</script>

<style scoped lang="sass">
// 搜尋輸入框最大寬度
.search-field
  max-width: 25rem
</style>
